import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { FileOrderDetails, QueryTranslationRequestFileOrderDetailsArgs } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TData = FileOrderDetails;
type TVariables = QueryTranslationRequestFileOrderDetailsArgs;

const MOCK: TVariables = { guid: '' };

export const useTranslationRequestFileOrderDetailsResult = (
  variables: TVariables = MOCK,
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query translationRequestFileOrderDetails($guid: String!) {
      translationRequestFileOrderDetails(guid: $guid) {
        orderDetails {
          details {
            cost
            currency
            languageCode
            pricePerWord
            savings
            words
            duplicateContent
          }
          detailsTotal
        }
        wordCount
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['translationRequestFileOrderDetailsResult', variables.guid],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql,
          variables
        }
      })
  });
};
